<div class="modal-dialog">
  <div class="modal-content" cdkTrapFocus>
    <div class="goreact-modal-header">
      <h4 class="modal-title">
        <span>
          @switch (data.mode) {
            @case ('add') {
              <span>
                @switch (data.contentType) {
                  @case ('media') {
                    <span translate="collection-destination_title-media-add"></span>
                  }
                  @case ('rubric') {
                    <span translate="collection-destination_title-rubric-add"></span>
                  }
                  @case ('markers') {
                    <span translate="collection-destination_title-markers-add"></span>
                  }
                  @case ('document') {
                    <span translate="collection-destination_title-document-add"></span>
                  }
                  @case ('activity') {
                    <span translate="collection-destination_title-activity-add"></span>
                  }
                }
              </span>
            }
            @case ('copy') {
              <span>
                @switch (data.contentType) {
                  @case ('media') {
                    <span translate="collection-destination_title-media-copy"></span>
                  }
                  @case ('rubric') {
                    <span translate="collection-destination_title-rubric-copy"></span>
                  }
                  @case ('markers') {
                    <span translate="collection-destination_title-markers-copy"></span>
                  }
                  @case ('document') {
                    <span translate="collection-destination_title-document-copy"></span>
                  }
                  @case ('activity') {
                    <span translate="collection-destination_title-activity-copy"></span>
                  }
                  @case ('all') {
                    <span translate="collection-destination_title-all-copy"></span>
                  }
                }
              </span>
            }
            @case ('move') {
              <span>
                @switch (data.contentType) {
                  @case ('media') {
                    <span translate="collection-destination_title-media-move"></span>
                  }
                  @case ('rubric') {
                    <span translate="collection-destination_title-rubric-move"></span>
                  }
                  @case ('markers') {
                    <span translate="collection-destination_title-markers-move"></span>
                  }
                  @case ('document') {
                    <span translate="collection-destination_title-document-move"></span>
                  }
                  @case ('activity') {
                    <span translate="collection-destination_title-activity-move"></span>
                  }
                  @case ('all') {
                    <span translate="collection-destination_title-all-move"></span>
                  }
                }
              </span>
            }
            @case ('restore') {
              <span>
                @switch (data.contentType) {
                  @case ('media') {
                    <span translate="collection-destination_title-media-restore"></span>
                  }
                  @case ('rubric') {
                    <span translate="collection-destination_title-rubric-restore"></span>
                  }
                  @case ('markers') {
                    <span translate="collection-destination_title-markers-restore"></span>
                  }
                  @case ('document') {
                    <span translate="collection-destination_title-document-restore"></span>
                  }
                  @case ('activity') {
                    <span translate="collection-destination_title-activity-restore"></span>
                  }
                }
              </span>
            }
            @case ('addToLibrary') {
              <span>
                @switch (data.contentType) {
                  @case ('activity') {
                    <span translate="collection-destination_title-activity-add-to-library"></span>
                  }
                }
              </span>
            }
          }
        </span>
      </h4>
      <button
        class="close-btn"
        type="button"
        [attr.aria-label]="('common_close' | translate)"
        (click)="dismiss()">
        <i class="ficon-app-x"></i>
      </button>
    </div>
    <div class="goreact-modal-body" tabindex="0">
      <div class="form-div" [formGroup]="form" #content goRequiredFieldsNote>
        @if (data.showNameField) {
          <mat-form-field appearance="outline" class="activity-form">
            <mat-label translate="collection-destination_assignment_name-label"></mat-label>
            <input matInput formControlName="name" />
            @if (form.controls.name.hasError('required')) {
              <mat-error
                translate="collection-destination_assignment_name-error-required">
              </mat-error>
            }
          </mat-form-field>
        }
        <mat-form-field appearance="outline">
          <mat-label translate="collection-destination_collection-label"></mat-label>
          <mat-select
            formControlName="selectedCollection"
            (selectionChange)="loadFolders()"
            disableOptionCentering
            panelClass="offsetPanel"
            required>
            @for (collection of collections; track collection) {
              <mat-option
                [value]="collection">
                {{ collection.name }}
              </mat-option>
            }
          </mat-select>
          <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
          @if (form.controls.selectedCollection.hasError('required')) {
            <mat-error
              translate="collection-destination_assignment_name-error-required">
            </mat-error>
          }
        </mat-form-field>
        @if (useTreeView && folders.length > 0) {
          <ngx-folder-tree-select
            formControlName="selectedFolder"
            [folders]="folders"
            [showNoneOption]="true"
            [maxDepth]="3"
            (availableFoldersChange)="onAvailableFoldersChange($event)">
          </ngx-folder-tree-select>
        } @else {
          @if (folders.length > 1 && (foldersLoading$ | async) === false) {
            <mat-form-field appearance="outline">
              <mat-label translate="collection-destination_folder-label"></mat-label>
              <mat-select
                formControlName="selectedFolder"
                data-cy="folder-selection"
                [placeholder]="'common_none' | translate"
                disableOptionCentering
                panelClass="offsetPanel data-cy-folder-panel">
                @for (folder of folders; track folder) {
                  <mat-option
                    [value]="folder">
                    {{ folder.name }}
                  </mat-option>
                }
              </mat-select>
              <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
            </mat-form-field>
          }
        }
      </div>
    </div>
    <div class="goreact-modal-footer">
      <span class="left">
        @if (data.allowSkip) {
          <button
            type="button"
            data-cy="skip-collection-btn"
            class="goreact-btn link-btn skip-btn"
            (click)="skipCollection()"
            translate="collection-destination_dont-save">
          </button>
        }
        <button
          type="button"
          data-cy="add-folder-on-destination"
          class="link-btn add-btn goreact-btn"
          [attr.aria-label]="('library-collections_add-folder-aria' | translate)"
          (click)="openAddFolderModal()">
          <span translate="library-collections_add-folder"></span>
        </button>
      </span>
      <span class="right">
        <button
          id="cancel-collection-btn"
          type="button"
          class="goreact-btn tertiary-btn"
          (click)="dismiss()"
          translate="common_cancel">
        </button>
        <button
          type="button"
          data-cy="choose-collection-next"
          class="goreact-btn primary-btn primary-btn-action"
          [focusOnFirstInvalidField]="{formGroup: form, formWrapper: content}"
          (click)="close()">
          @if (data.submitText) {
            <span>{{ data.submitText | translate }}</span>
          } @else {
            <span>
              @switch (data.mode) {
                @case ('add') {
                  <span translate="common_next"></span>
                }
                @case ('copy') {
                  <span translate="common_save"></span>
                }
                @case ('move') {
                  <span translate="common_save"></span>
                }
                @case ('restore') {
                  <span translate="common_restore"></span>
                }
                @case ('addToLibrary') {
                  <span translate="common_copy"></span>
                }
              }
            </span>
          }
        </button>
      </span>
    </div>
  </div>
</div>
